@import 'styles/variables';

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
  border-radius: 10px;
  border: 1px solid var(--Dark-8, rgba(0, 0, 0, 0.08));
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  font-family: Sohne;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  line-height: 14.7px;
  letter-spacing: 0.42px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:active {
    transform: translateY(0);
  }

  svg {
    flex-shrink: 0;
    display: block;
    width: 42px;
    height: 42px;
  }

  span {
    color: white;
    font-weight: 500;
    line-height: 1;
    display: flex;
    align-items: center;
  }
}

.linkedin {
  background: linear-gradient(180deg, #2582e8 0.91%, #1c6bc1 100.91%);
  border: 1px solid rgba(37, 130, 232, 0.2);

  &:hover {
    background: linear-gradient(180deg, #2988ed 0.91%, #1e70c6 100.91%);
    border: 1px solid rgba(41, 136, 237, 0.2);
  }
}
.facebook {
  background: linear-gradient(180deg, #338cff 0.91%, #006ffb 100.91%);
  border: 1px solid rgba(51, 140, 255, 0.2);

  &:hover {
    background: linear-gradient(180deg, #4a96ff 0.91%, #1a7bfc 100.91%);
    border: 1px solid rgba(74, 150, 255, 0.2);
  }
}

.instagram {
  background: radial-gradient(circle at 65% 130%, #ffc800 0%, #ff8a00 20%, #ff5478 40%, #ff00c6 70%, #8c3aaa 100%),
    radial-gradient(circle at 80% 20%, rgba(140, 58, 170, 0) 40%, rgba(140, 58, 170, 0.8) 100%);
  border: 1px solid rgba(255, 200, 0, 0.3);

  &:hover {
    background: radial-gradient(circle at 65% 110%, #ffd010 0%, #ff9a10 15%, #ff6488 30%, #ff10d6 62%, #9c4aba 100%),
      radial-gradient(circle at 80% 20%, rgba(150, 68, 180, 0) 50%, rgba(150, 68, 180, 0.6) 100%);
    border: 1px solid rgba(255, 208, 16, 0.3);
  }
}

.twitter {
  background: linear-gradient(290deg, #707070 0%, #0d0d0d 100%);
  border: 1px solid rgba(112, 112, 112, 0.3);

  &:hover {
    background: linear-gradient(290deg, #808080 0%, #1a1a1a 100%);
    border: 1px solid rgba(128, 128, 128, 0.3);
  }
}

.youtube {
  background: linear-gradient(180deg, #f71b1b 0%, #c10c0c 100%);

  &:hover {
    background: linear-gradient(180deg, #f82b2b 0%, #d11c1c 100%);
  }
}

.tiktok {
  background: linear-gradient(0deg, #010101 0%, #363636 100%);

  &:hover {
    background: linear-gradient(0deg, #111111 0%, #464646 100%);
  }
}

.mailchimp {
  background: #ffcd07;

  span {
    color: #333;
  }

  &:hover {
    background: #ffd517;
  }
}

.wordpress {
  background: linear-gradient(0deg, #171a1f 0%, #2b2f38 100%);

  &:hover {
    background: linear-gradient(0deg, #272a2f 0%, #3b3f48 100%);
  }
}

.gohighlevel {
  background: linear-gradient(0deg, #08223d 0%, #255281 100%);

  &:hover {
    background: linear-gradient(0deg, #18324d 0%, #356291 100%);
  }
}

.google {
  background: linear-gradient(0deg, #e47700 0%, #f8a801 100%);
  border: 1px solid rgba(228, 119, 0, 0.2);

  &:hover {
    background: linear-gradient(0deg, #f48710 0%, #f9b211 100%);
    border: 1px solid rgba(244, 135, 16, 0.2);
  }
}

.metaads {
  background: linear-gradient(180deg, #1877f2 0%, #1565c0 100%);

  &:hover {
    background: linear-gradient(180deg, #2b85f7 0%, #1e6bc5 100%);
  }
}
